<div class="main-wrapper" [class.shifted]="isSidebarOpen">
  <div class="chat-container"> 

    <!-- && username (delete this text: add back to main-wrapper)--> 

    <!-- Sidebar -->
    <app-sidebar
      [isOpen]="isSidebarOpen"
      (toggleSidebar)="toggleSidebar()"
      (newChat)="onNewChat()"
      (chatSelected)="onChatSelected($event)">
    </app-sidebar>

    <!-- Mobile overlay for sidebar -->
    <div 
      class="mobile-overlay" 
      *ngIf="isSidebarOpen" 
      (click)="toggleSidebar()">
    </div>

    <!-- *ngIf="username" -->


    <!-- Topbar -->
    <app-topbar 
      [isSidebarOpen]="isSidebarOpen"
      [hasShadow]="hasOverflow"
      [appMode]="appMode"
      (toggleSidebar)="toggleSidebar()"
      (newChat)="onNewChat()">
    </app-topbar>

    <!-- Place inside app-topbar for login -->
    <!-- (logout)="logout()" -->
    <!-- [username]="username"  -->

    <!-- Chat Messages -->
    <div class="chat-messages" #messagesContainer>
      <div class="scrollable-content">
        <div class="chat-content-wrapper">

          <!-- Chat loop -->
          <div *ngFor="let message of chatMessages; let i = index"
          class="chat-message-wrapper"
          [ngClass]="{ 'user': message.sender === 'user', 'bot': message.sender === 'bot' }">
                 
            <!-- Pasted/attached image preview inside the user bubble (click to expand) -->
            <div *ngIf="message.imageUrl && message.sender === 'user'" class="message-image-wrap"
                 (click)="openLightbox(message.imageUrl!); $event.stopPropagation()">
              <img [src]="message.imageUrl" alt="Attached image" class="message-image" />
            </div>

            <!-- Uploaded file chip (click to re-download), like ChatGPT -->
            <div *ngIf="message.fileAttachment && message.sender === 'user'" class="message-file-wrap">
              <button type="button" class="message-file-chip"
                      (click)="downloadFileAttachment(message.fileAttachment!)"
                      [title]="'Download ' + message.fileAttachment.name">
                <img src="assets/custom-icons/document.svg" alt="File" class="file-chip-icon" />
                <span class="file-chip-name">{{ message.fileAttachment.name }}</span>
                <img src="assets/custom-icons/upload.svg" alt="Download" class="file-chip-dl" />
              </button>
            </div>

            <!-- File Previews Above User Message -->
            <div *ngIf="message.files?.length && message.sender === 'user'" class="file-preview-stack">
              <app-uploadcontent
                *ngFor="let file of message.files"
                [file]="file"
                [showRemoveButton]="false">
              </app-uploadcontent>
            </div>

            <!-- Chat Bubble -->
            <div class="chat-bubble" 
            [class.user]="message.sender === 'user'" 
            [class.bot]="message.sender === 'bot'"
            [class.has-files-above]="message.sender === 'user' && message.files?.length">       
              <div class="message-content-wrapper">
                <div class="message-content" [innerHTML]="message.text" (click)="onMessageClick($event)"></div>
                <span *ngIf="message.isTyping" class="typing-circle" [class.active]="botIsTyping"></span>
              </div>

              <!-- Rendered chart image (bot) — click to expand, with copy/download -->
              <div *ngIf="message.chartImageUrl" class="chart-block">
                <img [src]="message.chartImageUrl" alt="Generated chart" class="chart-image"
                     (click)="openLightbox(message.chartImageUrl!)" />
                <div class="chart-actions">
                  <button type="button" class="chart-action-btn" (click)="copyChart(message.chartImageUrl!)" title="Copy image">
                    <img src="assets/custom-icons/copy.svg" alt="Copy" />
                    <span>Copy</span>
                  </button>
                  <button type="button" class="chart-action-btn" (click)="downloadChart(message.chartImageUrl!)" title="Download PNG">
                    <img src="assets/custom-icons/upload.svg" alt="Download" />
                    <span>Download</span>
                  </button>
                </div>
              </div>

              <!-- Sources Section -->
              <div *ngIf="message.sender === 'bot' && !message.isTyping && message.sources && message.sources.length > 0"
                   class="sources-section">
                <div class="sources-label">Sources</div>
                <div class="sources-list">
                  <a *ngFor="let source of message.sources; let si = index"
                     [href]="buildSourceLink(source)"
                     target="_blank"
                     rel="noopener noreferrer"
                     class="source-chip">
                    <span class="source-num">[{{ si + 1 }}]</span> {{ getSourceDisplayName(source) }}
                  </a>
                </div>
              </div>

              <!-- Feedback Buttons -->
              <div *ngIf="message.sender === 'bot' && !message.isTyping && message.feedback !== undefined"
                   class="feedback-row">
                <button
                  class="feedback-btn"
                  (click)="copyAsCleanText(i)"
                  title="Copy as clean text (for Word)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                  </svg>
                </button>
                <button
                  class="feedback-btn"
                  [class.active]="message.feedback === 'up'"
                  (click)="submitFeedback(i, 'up')"
                  title="Helpful">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z"/>
                    <path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/>
                  </svg>
                </button>
                <button
                  class="feedback-btn"
                  [class.active]="message.feedback === 'down'"
                  (click)="submitFeedback(i, 'down')"
                  title="Not helpful">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3H10z"/>
                    <path d="M17 2h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div> 

    <!-- Chat Input Container -->
    <div class="chat-input-container" 
         [class.centered]="chatMessages.length === 0" 
         #chatInputContainer>

      <!-- Placeholder text when chat is empty -->
      <div class="topic-text" *ngIf="chatMessages.length === 0">
        {{ getRandomWelcomeMessage() }}
        <span *ngIf="isTyping && window.innerWidth > 768" class="typing-circle"></span>
      </div>

      <form [formGroup]="chatForm" class="chat-input" (ngSubmit)="sendMessage()">
        <div class="input-wrapper">

          <!-- File Upload Section -->
          <div class="uploaded-files">
            <app-uploadcontent
              *ngFor="let file of selectedFiles; let i = index"
              [file]="file"
              (removeFile)="onFileRemoved(i)">
            </app-uploadcontent>
          </div>

          <!-- ===== WRITING MODE: just the tab selector; user types in the main input ===== -->
          <div class="writing-tabs" *ngIf="appMode === 'writing'">
            <button type="button" class="writing-tab" [class.active]="writingMode === 'review'" (click)="setWritingMode('review')">Review</button>
            <button type="button" class="writing-tab" [class.active]="writingMode === 'rewrite'" (click)="setWritingMode('rewrite')">Rewrite</button>
            <button type="button" class="writing-tab" [class.active]="writingMode === 'generate'" (click)="setWritingMode('generate')">Generate</button>
          </div>

          <!-- Prohibited-word warning (writing mode, client-side) -->
          <div class="prohibited-warning" *ngIf="appMode === 'writing' && flaggedWords.length > 0">
            FI style flags: <span class="flagged-word" *ngFor="let w of flaggedWords">{{ w }}</span>
          </div>

          <!-- Staged attachment preview (image paste / file pick, all modes) -->
          <div class="attachment-preview" *ngIf="attachedImage || attachedFile">
            <ng-container *ngIf="attachedImage">
              <img [src]="attachedImage.dataUri" alt="Pasted image" class="attachment-thumb" />
              <span class="attachment-name">Image attached</span>
            </ng-container>
            <ng-container *ngIf="attachedFile">
              <img src="assets/custom-icons/document.svg" alt="File" class="attachment-thumb file-thumb" />
              <span class="attachment-name">{{ attachedFile.name }}</span>
            </ng-container>
            <button type="button" class="attachment-remove" (click)="clearAttachment()" title="Remove attachment">
              <img src="assets/custom-icons/close.svg" alt="Remove" />
            </button>
          </div>

          <!-- Text Input -->
          <div class="input-row">
            <textarea
              formControlName="message"
              [placeholder]="chatPlaceholder"
              class="input-field"
              rows="1"
              style="overflow: hidden; resize: none;"
              (input)="adjustTextareaHeight(); onWritingInput()"
              (paste)="onPaste($event)"
              (keydown)="handleKeydown($event)">
            </textarea>
          </div>

          <!-- Action Buttons -->
          <div class="button-row">
            <div class="left-buttons">
              <!-- Unified attach button (images → vision, files → ingest) -->
              <button type="button" class="attach-button" (click)="attachInput.click()" title="Attach image or file">
                <img src="assets/custom-icons/upload.svg" alt="Attach" class="attach-icon" />
              </button>
              <input
                #attachInput
                type="file"
                accept="image/*,.pdf,.docx,.xlsx,.csv,.txt"
                style="display:none"
                (change)="onAttachFile($event)"
              />
              <app-toggle
                [appMode]="appMode"
                [temperature]="getTemperature()"
                (modeChanged)="onModeChanged($event)"
                (contextUpdated)="updateContext($event)"
                (temperatureChange)="onTemperatureChanged($event)">
              </app-toggle>
              <!-- Live word count in writing mode -->
              <span class="word-count" *ngIf="appMode === 'writing' && inputWordCount > 0">{{ inputWordCount }} words</span>
            </div>
            <button 
              type="button" 
              class="send-button" 
              [disabled]="!chatForm.valid && !isStopVisible && !attachedImage && !attachedFile" 
              (click)="isStopVisible ? stopBotResponse() : sendMessage()">
              <img 
                *ngIf="!isStopVisible" 
                src="assets/custom-icons/send.svg" 
                alt="Send Icon" 
                class="send-icon" 
              />
              <img 
                *ngIf="isStopVisible" 
                src="assets/custom-icons/stop.svg" 
                alt="Stop Icon" 
                class="stop-icon" 
              />
            </button>
          </div>    

        </div>
      </form>

    </div> 
    <p class="input-helper-text" *ngIf="!isChatInputCentered()">
      Chat history is saved locally. Please review responses.
    </p>
  </div>
</div>

<!-- Image lightbox — click an image to expand, click anywhere / × to close -->
<div class="lightbox-overlay" *ngIf="lightboxImageUrl" (click)="closeLightbox()">
  <button type="button" class="lightbox-close" (click)="closeLightbox(); $event.stopPropagation()" aria-label="Close">
    <img src="assets/custom-icons/close.svg" alt="Close" />
  </button>
  <img [src]="lightboxImageUrl" alt="Expanded image" class="lightbox-image" (click)="$event.stopPropagation()" />
</div>